export const allCountriesList = [
  {
    countryCode: 'AF',
    isoAlpha3: 'AFG',
  },
  {
    countryCode: 'AL',
    isoAlpha3: 'ALB',
  },
  {
    countryCode: 'DZ',
    isoAlpha3: 'DZA',
  },
  {
    countryCode: 'AS',
    isoAlpha3: 'ASM',
  },
  {
    countryCode: 'AD',
    isoAlpha3: 'AND',
  },
  {
    countryCode: 'AO',
    isoAlpha3: 'AGO',
  },
  {
    countryCode: 'AI',
    isoAlpha3: 'AIA',
  },
  {
    countryCode: 'AQ',
    isoAlpha3: 'ATA',
  },
  {
    countryCode: 'AG',
    isoAlpha3: 'ATG',
  },
  {
    countryCode: 'AR',
    isoAlpha3: 'ARG',
  },
  {
    countryCode: 'AM',
    isoAlpha3: 'ARM',
  },
  {
    countryCode: 'AW',
    isoAlpha3: 'ABW',
  },
  {
    countryCode: 'AU',
    isoAlpha3: 'AUS',
  },
  {
    countryCode: 'AT',
    isoAlpha3: 'AUT',
  },
  {
    countryCode: 'AZ',
    isoAlpha3: 'AZE',
  },
  {
    countryCode: 'BS',
    isoAlpha3: 'BHS',
  },
  {
    countryCode: 'BH',
    isoAlpha3: 'BHR',
  },
  {
    countryCode: 'BD',
    isoAlpha3: 'BGD',
  },
  {
    countryCode: 'BB',
    isoAlpha3: 'BRB',
  },
  {
    countryCode: 'BY',
    isoAlpha3: 'BLR',
  },
  {
    countryCode: 'BE',
    isoAlpha3: 'BEL',
  },
  {
    countryCode: 'BZ',
    isoAlpha3: 'BLZ',
  },
  {
    countryCode: 'BJ',
    isoAlpha3: 'BEN',
  },
  {
    countryCode: 'BM',
    isoAlpha3: 'BMU',
  },
  {
    countryCode: 'BT',
    isoAlpha3: 'BTN',
  },
  {
    countryCode: 'BO',
    isoAlpha3: 'BOL',
  },
  {
    countryCode: 'BQ',
    isoAlpha3: 'BES',
  },
  {
    countryCode: 'BA',
    isoAlpha3: 'BIH',
  },
  {
    countryCode: 'BW',
    isoAlpha3: 'BWA',
  },
  {
    countryCode: 'BV',
    isoAlpha3: 'BVT',
  },
  {
    countryCode: 'BR',
    isoAlpha3: 'BRA',
  },
  {
    countryCode: 'IO',
    isoAlpha3: 'IOT',
  },
  {
    countryCode: 'VG',
    isoAlpha3: 'VGB',
  },
  {
    countryCode: 'BN',
    isoAlpha3: 'BRN',
  },
  {
    countryCode: 'BG',
    isoAlpha3: 'BGR',
  },
  {
    countryCode: 'BF',
    isoAlpha3: 'BFA',
  },
  {
    countryCode: 'BI',
    isoAlpha3: 'BDI',
  },
  {
    countryCode: 'KH',
    isoAlpha3: 'KHM',
  },
  {
    countryCode: 'CM',
    isoAlpha3: 'CMR',
  },
  {
    countryCode: 'CA',
    isoAlpha3: 'CAN',
  },
  {
    countryCode: 'CV',
    isoAlpha3: 'CPV',
  },
  {
    countryCode: 'KY',
    isoAlpha3: 'CYM',
  },
  {
    countryCode: 'CF',
    isoAlpha3: 'CAF',
  },
  {
    countryCode: 'TD',
    isoAlpha3: 'TCD',
  },
  {
    countryCode: 'CL',
    isoAlpha3: 'CHL',
  },
  {
    countryCode: 'CN',
    isoAlpha3: 'CHN',
  },
  {
    countryCode: 'CX',
    isoAlpha3: 'CXR',
  },
  {
    countryCode: 'CC',
    isoAlpha3: 'CCK',
  },
  {
    countryCode: 'CO',
    isoAlpha3: 'COL',
  },
  {
    countryCode: 'KM',
    isoAlpha3: 'COM',
  },
  {
    countryCode: 'CK',
    isoAlpha3: 'COK',
  },
  {
    countryCode: 'CR',
    isoAlpha3: 'CRI',
  },
  {
    countryCode: 'HR',
    isoAlpha3: 'HRV',
  },
  {
    countryCode: 'CU',
    isoAlpha3: 'CUB',
  },
  {
    countryCode: 'CW',
    isoAlpha3: 'CUW',
  },
  {
    countryCode: 'CY',
    isoAlpha3: 'CYP',
  },
  {
    countryCode: 'CZ',
    isoAlpha3: 'CZE',
  },
  {
    countryCode: 'CD',
    isoAlpha3: 'COD',
  },
  {
    countryCode: 'DK',
    isoAlpha3: 'DNK',
  },
  {
    countryCode: 'DJ',
    isoAlpha3: 'DJI',
  },
  {
    countryCode: 'DM',
    isoAlpha3: 'DMA',
  },
  {
    countryCode: 'DO',
    isoAlpha3: 'DOM',
  },
  {
    countryCode: 'TL',
    isoAlpha3: 'TLS',
  },
  {
    countryCode: 'EC',
    isoAlpha3: 'ECU',
  },
  {
    countryCode: 'EG',
    isoAlpha3: 'EGY',
  },
  {
    countryCode: 'SV',
    isoAlpha3: 'SLV',
  },
  {
    countryCode: 'GQ',
    isoAlpha3: 'GNQ',
  },
  {
    countryCode: 'ER',
    isoAlpha3: 'ERI',
  },
  {
    countryCode: 'EE',
    isoAlpha3: 'EST',
  },
  {
    countryCode: 'ET',
    isoAlpha3: 'ETH',
  },
  {
    countryCode: 'FK',
    isoAlpha3: 'FLK',
  },
  {
    countryCode: 'FO',
    isoAlpha3: 'FRO',
  },
  {
    countryCode: 'FJ',
    isoAlpha3: 'FJI',
  },
  {
    countryCode: 'FI',
    isoAlpha3: 'FIN',
  },
  {
    countryCode: 'FR',
    isoAlpha3: 'FRA',
  },
  {
    countryCode: 'GF',
    isoAlpha3: 'GUF',
  },
  {
    countryCode: 'PF',
    isoAlpha3: 'PYF',
  },
  {
    countryCode: 'TF',
    isoAlpha3: 'ATF',
  },
  {
    countryCode: 'GA',
    isoAlpha3: 'GAB',
  },
  {
    countryCode: 'GM',
    isoAlpha3: 'GMB',
  },
  {
    countryCode: 'GE',
    isoAlpha3: 'GEO',
  },
  {
    countryCode: 'DE',
    isoAlpha3: 'DEU',
  },
  {
    countryCode: 'GH',
    isoAlpha3: 'GHA',
  },
  {
    countryCode: 'GI',
    isoAlpha3: 'GIB',
  },
  {
    countryCode: 'GR',
    isoAlpha3: 'GRC',
  },
  {
    countryCode: 'GL',
    isoAlpha3: 'GRL',
  },
  {
    countryCode: 'GD',
    isoAlpha3: 'GRD',
  },
  {
    countryCode: 'GP',
    isoAlpha3: 'GLP',
  },
  {
    countryCode: 'GU',
    isoAlpha3: 'GUM',
  },
  {
    countryCode: 'GT',
    isoAlpha3: 'GTM',
  },
  {
    countryCode: 'GG',
    isoAlpha3: 'GGY',
  },
  {
    countryCode: 'GN',
    isoAlpha3: 'GIN',
  },
  {
    countryCode: 'GW',
    isoAlpha3: 'GNB',
  },
  {
    countryCode: 'GY',
    isoAlpha3: 'GUY',
  },
  {
    countryCode: 'HT',
    isoAlpha3: 'HTI',
  },
  {
    countryCode: 'HM',
    isoAlpha3: 'HMD',
  },
  {
    countryCode: 'HN',
    isoAlpha3: 'HND',
  },
  {
    countryCode: 'HK',
    isoAlpha3: 'HKG',
  },
  {
    countryCode: 'HU',
    isoAlpha3: 'HUN',
  },
  {
    countryCode: 'IS',
    isoAlpha3: 'ISL',
  },
  {
    countryCode: 'IN',
    isoAlpha3: 'IND',
  },
  {
    countryCode: 'ID',
    isoAlpha3: 'IDN',
  },
  {
    countryCode: 'IR',
    isoAlpha3: 'IRN',
  },
  {
    countryCode: 'IQ',
    isoAlpha3: 'IRQ',
  },
  {
    countryCode: 'IE',
    isoAlpha3: 'IRL',
  },
  {
    countryCode: 'IM',
    isoAlpha3: 'IMN',
  },
  {
    countryCode: 'IL',
    isoAlpha3: 'ISR',
  },
  {
    countryCode: 'IT',
    isoAlpha3: 'ITA',
  },
  {
    countryCode: 'CI',
    isoAlpha3: 'CIV',
  },
  {
    countryCode: 'JM',
    isoAlpha3: 'JAM',
  },
  {
    countryCode: 'JP',
    isoAlpha3: 'JPN',
  },
  {
    countryCode: 'JE',
    isoAlpha3: 'JEY',
  },
  {
    countryCode: 'JO',
    isoAlpha3: 'JOR',
  },
  {
    countryCode: 'KZ',
    isoAlpha3: 'KAZ',
  },
  {
    countryCode: 'KE',
    isoAlpha3: 'KEN',
  },
  {
    countryCode: 'KI',
    isoAlpha3: 'KIR',
  },
  {
    countryCode: 'XK',
    isoAlpha3: 'XKX',
  },
  {
    countryCode: 'KW',
    isoAlpha3: 'KWT',
  },
  {
    countryCode: 'KG',
    isoAlpha3: 'KGZ',
  },
  {
    countryCode: 'LA',
    isoAlpha3: 'LAO',
  },
  {
    countryCode: 'LV',
    isoAlpha3: 'LVA',
  },
  {
    countryCode: 'LB',
    isoAlpha3: 'LBN',
  },
  {
    countryCode: 'LS',
    isoAlpha3: 'LSO',
  },
  {
    countryCode: 'LR',
    isoAlpha3: 'LBR',
  },
  {
    countryCode: 'LY',
    isoAlpha3: 'LBY',
  },
  {
    countryCode: 'LI',
    isoAlpha3: 'LIE',
  },
  {
    countryCode: 'LT',
    isoAlpha3: 'LTU',
  },
  {
    countryCode: 'LU',
    isoAlpha3: 'LUX',
  },
  {
    countryCode: 'MO',
    isoAlpha3: 'MAC',
  },
  {
    countryCode: 'MK',
    isoAlpha3: 'MKD',
  },
  {
    countryCode: 'MG',
    isoAlpha3: 'MDG',
  },
  {
    countryCode: 'MW',
    isoAlpha3: 'MWI',
  },
  {
    countryCode: 'MY',
    isoAlpha3: 'MYS',
  },
  {
    countryCode: 'MV',
    isoAlpha3: 'MDV',
  },
  {
    countryCode: 'ML',
    isoAlpha3: 'MLI',
  },
  {
    countryCode: 'MT',
    isoAlpha3: 'MLT',
  },
  {
    countryCode: 'MH',
    isoAlpha3: 'MHL',
  },
  {
    countryCode: 'MQ',
    isoAlpha3: 'MTQ',
  },
  {
    countryCode: 'MR',
    isoAlpha3: 'MRT',
  },
  {
    countryCode: 'MU',
    isoAlpha3: 'MUS',
  },
  {
    countryCode: 'YT',
    isoAlpha3: 'MYT',
  },
  {
    countryCode: 'MX',
    isoAlpha3: 'MEX',
  },
  {
    countryCode: 'FM',
    isoAlpha3: 'FSM',
  },
  {
    countryCode: 'MD',
    isoAlpha3: 'MDA',
  },
  {
    countryCode: 'MC',
    isoAlpha3: 'MCO',
  },
  {
    countryCode: 'MN',
    isoAlpha3: 'MNG',
  },
  {
    countryCode: 'ME',
    isoAlpha3: 'MNE',
  },
  {
    countryCode: 'MS',
    isoAlpha3: 'MSR',
  },
  {
    countryCode: 'MA',
    isoAlpha3: 'MAR',
  },
  {
    countryCode: 'MZ',
    isoAlpha3: 'MOZ',
  },
  {
    countryCode: 'MM',
    isoAlpha3: 'MMR',
  },
  {
    countryCode: 'NA',
    isoAlpha3: 'NAM',
  },
  {
    countryCode: 'NR',
    isoAlpha3: 'NRU',
  },
  {
    countryCode: 'NP',
    isoAlpha3: 'NPL',
  },
  {
    countryCode: 'NL',
    isoAlpha3: 'NLD',
  },
  {
    countryCode: 'NC',
    isoAlpha3: 'NCL',
  },
  {
    countryCode: 'NZ',
    isoAlpha3: 'NZL',
  },
  {
    countryCode: 'NI',
    isoAlpha3: 'NIC',
  },
  {
    countryCode: 'NE',
    isoAlpha3: 'NER',
  },
  {
    countryCode: 'NG',
    isoAlpha3: 'NGA',
  },
  {
    countryCode: 'NU',
    isoAlpha3: 'NIU',
  },
  {
    countryCode: 'NF',
    isoAlpha3: 'NFK',
  },
  {
    countryCode: 'KP',
    isoAlpha3: 'PRK',
  },
  {
    countryCode: 'MP',
    isoAlpha3: 'MNP',
  },
  {
    countryCode: 'NO',
    isoAlpha3: 'NOR',
  },
  {
    countryCode: 'OM',
    isoAlpha3: 'OMN',
  },
  {
    countryCode: 'PK',
    isoAlpha3: 'PAK',
  },
  {
    countryCode: 'PW',
    isoAlpha3: 'PLW',
  },
  {
    countryCode: 'PS',
    isoAlpha3: 'PSE',
  },
  {
    countryCode: 'PA',
    isoAlpha3: 'PAN',
  },
  {
    countryCode: 'PG',
    isoAlpha3: 'PNG',
  },
  {
    countryCode: 'PY',
    isoAlpha3: 'PRY',
  },
  {
    countryCode: 'PE',
    isoAlpha3: 'PER',
  },
  {
    countryCode: 'PH',
    isoAlpha3: 'PHL',
  },
  {
    countryCode: 'PN',
    isoAlpha3: 'PCN',
  },
  {
    countryCode: 'PL',
    isoAlpha3: 'POL',
  },
  {
    countryCode: 'PT',
    isoAlpha3: 'PRT',
  },
  {
    countryCode: 'PR',
    isoAlpha3: 'PRI',
  },
  {
    countryCode: 'QA',
    isoAlpha3: 'QAT',
  },
  {
    countryCode: 'CG',
    isoAlpha3: 'COG',
  },
  {
    countryCode: 'RO',
    isoAlpha3: 'ROU',
  },
  {
    countryCode: 'RU',
    isoAlpha3: 'RUS',
  },
  {
    countryCode: 'RW',
    isoAlpha3: 'RWA',
  },
  {
    countryCode: 'RE',
    isoAlpha3: 'REU',
  },
  {
    countryCode: 'BL',
    isoAlpha3: 'BLM',
  },
  {
    countryCode: 'SH',
    isoAlpha3: 'SHN',
  },
  {
    countryCode: 'KN',
    isoAlpha3: 'KNA',
  },
  {
    countryCode: 'LC',
    isoAlpha3: 'LCA',
  },
  {
    countryCode: 'MF',
    isoAlpha3: 'MAF',
  },
  {
    countryCode: 'PM',
    isoAlpha3: 'SPM',
  },
  {
    countryCode: 'VC',
    isoAlpha3: 'VCT',
  },
  {
    countryCode: 'WS',
    isoAlpha3: 'WSM',
  },
  {
    countryCode: 'SM',
    isoAlpha3: 'SMR',
  },
  {
    countryCode: 'SA',
    isoAlpha3: 'SAU',
  },
  {
    countryCode: 'SN',
    isoAlpha3: 'SEN',
  },
  {
    countryCode: 'RS',
    isoAlpha3: 'SRB',
  },
  {
    countryCode: 'SC',
    isoAlpha3: 'SYC',
  },
  {
    countryCode: 'SL',
    isoAlpha3: 'SLE',
  },
  {
    countryCode: 'SG',
    isoAlpha3: 'SGP',
  },
  {
    countryCode: 'SX',
    isoAlpha3: 'SXM',
  },
  {
    countryCode: 'SK',
    isoAlpha3: 'SVK',
  },
  {
    countryCode: 'SI',
    isoAlpha3: 'SVN',
  },
  {
    countryCode: 'SB',
    isoAlpha3: 'SLB',
  },
  {
    countryCode: 'SO',
    isoAlpha3: 'SOM',
  },
  {
    countryCode: 'ZA',
    isoAlpha3: 'ZAF',
  },
  {
    countryCode: 'GS',
    isoAlpha3: 'SGS',
  },
  {
    countryCode: 'KR',
    isoAlpha3: 'KOR',
  },
  {
    countryCode: 'SS',
    isoAlpha3: 'SSD',
  },
  {
    countryCode: 'ES',
    isoAlpha3: 'ESP',
  },
  {
    countryCode: 'LK',
    isoAlpha3: 'LKA',
  },
  {
    countryCode: 'SD',
    isoAlpha3: 'SDN',
  },
  {
    countryCode: 'SR',
    isoAlpha3: 'SUR',
  },
  {
    countryCode: 'SJ',
    isoAlpha3: 'SJM',
  },
  {
    countryCode: 'SZ',
    isoAlpha3: 'SWZ',
  },
  {
    countryCode: 'SE',
    isoAlpha3: 'SWE',
  },
  {
    countryCode: 'CH',
    isoAlpha3: 'CHE',
  },
  {
    countryCode: 'SY',
    isoAlpha3: 'SYR',
  },
  {
    countryCode: 'ST',
    isoAlpha3: 'STP',
  },
  {
    countryCode: 'TW',
    isoAlpha3: 'TWN',
  },
  {
    countryCode: 'TJ',
    isoAlpha3: 'TJK',
  },
  {
    countryCode: 'TZ',
    isoAlpha3: 'TZA',
  },
  {
    countryCode: 'TH',
    isoAlpha3: 'THA',
  },
  {
    countryCode: 'TG',
    isoAlpha3: 'TGO',
  },
  {
    countryCode: 'TK',
    isoAlpha3: 'TKL',
  },
  {
    countryCode: 'TO',
    isoAlpha3: 'TON',
  },
  {
    countryCode: 'TT',
    isoAlpha3: 'TTO',
  },
  {
    countryCode: 'TN',
    isoAlpha3: 'TUN',
  },
  {
    countryCode: 'TR',
    isoAlpha3: 'TUR',
  },
  {
    countryCode: 'TM',
    isoAlpha3: 'TKM',
  },
  {
    countryCode: 'TC',
    isoAlpha3: 'TCA',
  },
  {
    countryCode: 'TV',
    isoAlpha3: 'TUV',
  },
  {
    countryCode: 'UM',
    isoAlpha3: 'UMI',
  },
  {
    countryCode: 'VI',
    isoAlpha3: 'VIR',
  },
  {
    countryCode: 'UG',
    isoAlpha3: 'UGA',
  },
  {
    countryCode: 'UA',
    isoAlpha3: 'UKR',
  },
  {
    countryCode: 'AE',
    isoAlpha3: 'ARE',
  },
  {
    countryCode: 'GB',
    isoAlpha3: 'GBR',
  },
  {
    countryCode: 'US',
    isoAlpha3: 'USA',
  },
  {
    countryCode: 'UY',
    isoAlpha3: 'URY',
  },
  {
    countryCode: 'UZ',
    isoAlpha3: 'UZB',
  },
  {
    countryCode: 'VU',
    isoAlpha3: 'VUT',
  },
  {
    countryCode: 'VA',
    isoAlpha3: 'VAT',
  },
  {
    countryCode: 'VE',
    isoAlpha3: 'VEN',
  },
  {
    countryCode: 'VN',
    isoAlpha3: 'VNM',
  },
  {
    countryCode: 'WF',
    isoAlpha3: 'WLF',
  },
  {
    countryCode: 'EH',
    isoAlpha3: 'ESH',
  },
  {
    countryCode: 'YE',
    isoAlpha3: 'YEM',
  },
  {
    countryCode: 'ZM',
    isoAlpha3: 'ZMB',
  },
  {
    countryCode: 'ZW',
    isoAlpha3: 'ZWE',
  },
  {
    countryCode: 'AX',
    isoAlpha3: 'ALA',
  },
]

export const countryTranslations = {
  af: 'Afghanistan',
  al: 'Albania',
  dz: 'Algeria',
  as: 'American Samoa',
  ad: 'Andorra',
  ao: 'Angola',
  ai: 'Anguilla',
  aq: 'Antarctica',
  ag: 'Antigua and Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  aw: 'Aruba',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  by: 'Belarus',
  be: 'Belgium',
  bz: 'Belize',
  bj: 'Benin',
  bm: 'Bermuda',
  bt: 'Bhutan',
  bo: 'Bolivia',
  bq: 'Bonaire',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  bv: 'Bouvet Island',
  br: 'Brazil',
  io: 'British Indian Ocean Territory',
  vg: 'British Virgin Islands',
  bn: 'Brunei',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cv: 'Cape Verde',
  ky: 'Cayman Islands',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  cx: 'Christmas Island',
  cc: 'Cocos [Keeling] Islands',
  co: 'Colombia',
  km: 'Comoros',
  ck: 'Cook Islands',
  cr: 'Costa Rica',
  hr: 'Croatia',
  cu: 'Cuba',
  cw: 'Curacao',
  cy: 'Cyprus',
  cz: 'Czechia',
  cd: 'Democratic Republic of the Congo',
  dk: 'Denmark',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  tl: 'East Timor',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  ee: 'Estonia',
  et: 'Ethiopia',
  fk: 'Falkland Islands',
  fo: 'Faroe Islands',
  fj: 'Fiji',
  fi: 'Finland',
  fr: 'France',
  gf: 'French Guiana',
  pf: 'French Polynesia',
  tf: 'French Southern Territories',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  de: 'Germany',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gr: 'Greece',
  gl: 'Greenland',
  gd: 'Grenada',
  gp: 'Guadeloupe',
  gu: 'Guam',
  gt: 'Guatemala',
  gg: 'Guernsey',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hm: 'Heard Island and McDonald Islands',
  hn: 'Honduras',
  hk: 'Hong Kong',
  hu: 'Hungary',
  is: 'Iceland',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran',
  iq: 'Iraq',
  ie: 'Ireland',
  im: 'Isle of Man',
  il: 'Israel',
  it: 'Italy',
  ci: 'Ivory Coast',
  jm: 'Jamaica',
  jp: 'Japan',
  je: 'Jersey',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  xk: 'Kosovo',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: 'Laos',
  lv: 'Latvia',
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libya',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mo: 'Macao',
  mk: 'Macedonia',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mt: 'Malta',
  mh: 'Marshall Islands',
  mq: 'Martinique',
  mr: 'Mauritania',
  mu: 'Mauritius',
  yt: 'Mayotte',
  mx: 'Mexico',
  fm: 'Micronesia',
  md: 'Moldova',
  mc: 'Monaco',
  mn: 'Mongolia',
  me: 'Montenegro',
  ms: 'Montserrat',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar [Burma]',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nl: 'Netherlands',
  nc: 'New Caledonia',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  nu: 'Niue',
  nf: 'Norfolk Island',
  kp: 'North Korea',
  mp: 'Northern Mariana Islands',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestine',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pn: 'Pitcairn Islands',
  pl: 'Poland',
  pt: 'Portugal',
  pr: 'Puerto Rico',
  qa: 'Qatar',
  cg: 'Republic of the Congo',
  ro: 'Romania',
  ru: 'Russia',
  rw: 'Rwanda',
  re: 'Réunion',
  bl: 'Saint Barthélemy',
  sh: 'Saint Helena',
  kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia',
  mf: 'Saint Martin',
  pm: 'Saint Pierre and Miquelon',
  vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa',
  sm: 'San Marino',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  rs: 'Serbia',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sx: 'Sint Maarten',
  sk: 'Slovakia',
  si: 'Slovenia',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  gs: 'South Georgia and the South Sandwich Islands',
  kr: 'South Korea',
  ss: 'South Sudan',
  es: 'Spain',
  lk: 'Sri Lanka',
  sd: 'Sudan',
  sr: 'Suriname',
  sj: 'Svalbard and Jan Mayen',
  sz: 'Swaziland',
  se: 'Sweden',
  ch: 'Switzerland',
  sy: 'Syria',
  st: 'São Tomé and Príncipe',
  tw: 'Taiwan',
  tj: 'Tajikistan',
  tz: 'Tanzania',
  th: 'Thailand',
  tg: 'Togo',
  tk: 'Tokelau',
  to: 'Tonga',
  tt: 'Trinidad and Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tc: 'Turks and Caicos Islands',
  tv: 'Tuvalu',
  um: 'U.S. Minor Outlying Islands',
  vi: 'U.S. Virgin Islands',
  ug: 'Uganda',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  gb: 'United Kingdom',
  us: 'United States of America',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  va: 'Vatican City',
  ve: 'Venezuela',
  vn: 'Vietnam',
  wf: 'Wallis and Futuna',
  eh: 'Western Sahara',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe',
  ax: 'Åland',
}
